import { FILTRES_PAR_DEFAUT, PAR_PAGE, type FiltresListe, type TriDossiers } from './listeDossiers';

/**
 * État de la liste des dossiers gardé en mémoire pendant qu'une fiche est
 * ouverte sur sa page (/dossiers/:id) : le retour à la liste retrouve les
 * filtres, la recherche, le tri et la page quittés.
 */
export interface EtatListeMemorise {
  filters: FiltresListe;
  rechercheSaisie: string;
  tri: TriDossiers;
  currentPage: number;
  itemsPerPage: number;
  showAdvancedFilters: boolean;
  /** Position de défilement de la liste au moment où elle a été quittée. */
  defilement?: number;
}

export const ETAT_LISTE_PAR_DEFAUT: EtatListeMemorise = {
  filters: FILTRES_PAR_DEFAUT,
  rechercheSaisie: '',
  tri: 'createdAt',
  currentPage: 1,
  itemsPerPage: PAR_PAGE,
  showAdvancedFilters: false,
};

/**
 * État de départ de la liste à son montage :
 * - un filtre demandé par la barre latérale l'emporte (défauts + ce statut) ;
 * - sinon l'état mémorisé (retour depuis une fiche) ;
 * - sinon les défauts.
 */
export function etatInitialListe(memoire: EtatListeMemorise | null, filtreDemande: string | null): EtatListeMemorise {
  if (filtreDemande !== null) {
    return { ...ETAT_LISTE_PAR_DEFAUT, filters: { ...FILTRES_PAR_DEFAUT, status: filtreDemande } };
  }
  if (memoire) return { ...memoire, filters: { ...memoire.filters } };
  return { ...ETAT_LISTE_PAR_DEFAUT, filters: { ...FILTRES_PAR_DEFAUT } };
}

/** Défilement à rétablir au montage de la liste : seulement au retour d'une fiche. */
export function defilementARetablir(depart: EtatListeMemorise): number {
  return depart.defilement && depart.defilement > 0 ? depart.defilement : 0;
}
